import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "0372ab31-fe84-4e72-ad16-f75a3c375352",
    content: "Sound sample",
    options: { clickAudioUrl: `${config.ASSETS_URL}/03/23/task/task-2-sample-1.wav` },
  },
  {
    id: "bf0e83fd-41a6-4920-a359-7a2eb3adb1f4",
    content: "Sound sample",
    options: { clickAudioUrl: `${config.ASSETS_URL}/03/23/task/task-2-sample-2.wav` },
  },
  {
    id: "a6342a8b-3b4d-44ed-a84f-fb037ca363e3",
    content: "Sound sample",
    options: { clickAudioUrl: `${config.ASSETS_URL}/03/23/task/task-2-sample-3.wav` },
  },
  {
    id: "7791597a-c6ca-4c6f-84ad-1b55cfbf9562",
    content: "Sound sample",
    options: { clickAudioUrl: `${config.ASSETS_URL}/03/23/task/task-2-sample-4.wav` },
  },
];

const groups = [
  { id: "03b812bd-e887-4a7f-a6a6-a7e345c40526", content: "Center", options: {} },
  { id: "a2c637af-3900-4600-8dbe-08d5ccc1a493", content: "Left", options: {} },
  { id: "60b68163-a688-4e96-9405-9f0fbf404772", content: "Top back left", options: {} },
  { id: "84853bee-9246-421f-802e-4496ec759394", content: "Right surround", options: {} },
];

export const task: Task = {
  id: "6df63fa4-528c-4e05-8aa1-2ebdadee56e5",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "03b812bd-e887-4a7f-a6a6-a7e345c40526", itemsId: ["0372ab31-fe84-4e72-ad16-f75a3c375352"] },
    { groupId: "a2c637af-3900-4600-8dbe-08d5ccc1a493", itemsId: ["7791597a-c6ca-4c6f-84ad-1b55cfbf9562"] },
    { groupId: "60b68163-a688-4e96-9405-9f0fbf404772", itemsId: ["bf0e83fd-41a6-4920-a359-7a2eb3adb1f4"] },
    { groupId: "84853bee-9246-421f-802e-4496ec759394", itemsId: ["a6342a8b-3b4d-44ed-a84f-fb037ca363e3"] },
  ],
};
